import _ from 'underscore';
import {
  pluginConfig,
  basicGridConfig,
  TargetingSettingsContext
} from '@bingads-webui-campaign/targeting-settings-scaffolds';

function getQuickFilterConfig() {
  const recommendationFilterItem = {
    key: 'recommendation',
    text: TargetingSettingsContext.i18n.getString('Filter_Recommendation'),
    value: {
      query: {
        RecommendationTypes: {
          $eq: 'NewTargets',
        },
      },
    },
    classes: 'quick-filter-all-recommendation',
  };
  const quickFilter = {
    items: [{
      key: 'all',
      text: TargetingSettingsContext.i18n.getString('Dashboard_AllCampaigns'),
      value: {
        query: {},
      },
      classes: 'quick-filter-all',
    }, {
      key: 'active',
      text: TargetingSettingsContext.i18n.getString('Dashboard_AllEnabledCampaigns'),
      value: {
        query: {
          Status: {
            $in: [
              'Enum.CampaignStatus\'Active\'',
              'Enum.CampaignStatus\'BudgetPaused\'',
            ],
          },
        },
      },
      classes: 'quick-filter-all-active',
    }].concat([recommendationFilterItem]),
  };
  return quickFilter;
}

const pluginsConfig = (view, columnChooser, perfMarker) => {
  const lowerToolbar = {
    items: [{
      type: 'button',
      text: TargetingSettingsContext.i18n.getString('Grid_CreateCampaignButtonText'),
      classes: ['btn', 'btn-primary'],
      onClick: () => {
        TargetingSettingsContext.router.navigateToRoute('campaign_create_objective');
      },
      disabled: TargetingSettingsContext.pageContext.Permissions.IsReadOnlyUser
        || TargetingSettingsContext.config.get('CurrentAccountInActive'),
    }, {
      type: 'dropdown',
      id: 'dropdown-edit',
      disabled: TargetingSettingsContext.pageContext.Permissions.IsReadOnlyUser
        || TargetingSettingsContext.config.get('CurrentAccountInActive'),
    }, {
      type: 'selector',
      id: 'quick-filter',
    }, {
      type: 'dropdown',
      id: 'dropdown-column-chooser',
    }],
  };

  return _.extend({}, pluginConfig(view, columnChooser), {
    a11y: { i18n: TargetingSettingsContext.i18n },
    toolbar: {
      'lower-toolbar': lowerToolbar,
    },
    crossPageSelectAll: {
      i18n: TargetingSettingsContext.i18n,
    },
    quickFilter: getQuickFilterConfig(),
    placeholder: {
      viewRoot: view.$el,
      container: '.noresult-container',
      text: TargetingSettingsContext.i18n.getString('Grid_NoRecords'),
      filteredContainer: '.noresult-container',
      filteredEmptyText: TargetingSettingsContext.i18n.getString('Grid_NoFilteredRecords'),
    },
    perfMarker: {
      marker: perfMarker,
      appConfig: TargetingSettingsContext.config,
    },
  });
};

export default class SettingsGridConfig {
  constructor(view, columnConfig, repository, perfMarker) {
    _.extend(this, basicGridConfig(), {
      name: 'settings_settings',
      dataSource: repository.getDataSource(),
      query: repository.getQuery(),
      columns: columnConfig.getColumnsConfig(),
      plugins: pluginsConfig(view, columnConfig.getColumnChooserConfig(), perfMarker),
      preferenceService: TargetingSettingsContext.preferencesService,
      config: TargetingSettingsContext.config,
    });
  }
}
